import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectReleasesNoteRoute: InvariantJiraRoute = {
	name: 'legacy-project-releases-note',
	path: '/jira/secure/ReleaseNote.jspa',
	query: ['projectId', 'version'],
};
